<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent width="fit-content" content-class="round-2xl")
  v-card.neutral700
    v-card-title.py-2
      v-spacer
      v-btn(icon @click="closeDialog" small color="neutral100")
        v-icon mdi-close
    v-card-text
      //- img(:src="image" loading="eager" :style="`max-height: ${getHeight};`")
      v-img(:src="image" eager contain max-width="90vw" :max-height="maxImageHeight")
        template(#placeholder)
          .d-flex.justify-center.align-center.fill-height
            v-progress-circular(:width="3" :size="75" color="white" indeterminate)
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    image: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters({ displaySize: 'ui/getDisplaySize' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    getHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '120vh'
        case 'x-small':
          return '110vh'
        case 'small':
          return '100vh'
        case 'medium':
          return '89vh'
        case 'large':
          return '80vh'
        case 'x-large':
          return '72vh'
        default:
          return '80vh'
      }
    },
    maxImageHeight () {
      let dialogHeight = window.innerHeight * 0.9
      let videoHeight = dialogHeight - 44 - 20
      return videoHeight + 'px'
    },
  },
  methods: {
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
.fit-content {
  width: fit-content !important;
}
</style>